import bannersMock from "#/api/server/mock/banners.json";
import benefitsMock from "#/api/server/mock/benefits.json";
import categoriesMock from "#/api/server/mock/categories.json";
import categoryPartnerActiveMock from "#/api/server/mock/category-partner-active.json";
import logoByProvider from "#/api/server/mock/get-image-by-provider.json";
import providersMock from "#/api/server/mock/get-providers-actived.json";
import locationMock from "#/api/server/mock/location.json";
import partnerBenefitsMock from "#/api/server/mock/partnerBenefits.json";
import pix from "#/api/server/mock/pix.mock";
import savedCellphoneEdit from "#/api/server/mock/rv-cellphone-topups-saved-cellphone-edit.mock.json";
import savedCellphoneList from "#/api/server/mock/rv-cellphone-topups-saved-cellphone-list.mock.json";
import savedCellphoneRemove from "#/api/server/mock/rv-cellphone-topups-saved-cellphone-remove.mock.json";
import cellphoneTransactionCancel from "#/api/server/mock/rv-cellphone-topups-transactions-cancel.mock.json";
import cellphoneTransactionResponse from "#/api/server/mock/rv-cellphone-topups-transactions-response.json";
import pinCartValues from "#/api/server/mock/rv-pin-cart-values.json";
import pinOrientation from "#/api/server/mock/rv-pin-orientation.json";
import pinValue from "#/api/server/mock/rv-pin-value.json";
import pinValues from "#/api/server/mock/rv-pin-values.json";
import portfolioDestaqueAtivo from "#/api/server/mock/rv-portfolio-destaque-ativo.json";
import portfolioProvidersCellphoneValues from "#/api/server/mock/rv-portfolio-providers-cellphone-values.mock.json";
import tvOffer from "#/api/server/mock/rv-tv-offer.json";
import tvOffers from "#/api/server/mock/rv-tv-offers.json";
import tvEditSignerCode from "#/api/server/mock/rv-tv-saved-signercode-edit.json";
import tvListSignerCode from "#/api/server/mock/rv-tv-saved-signercode-list.json";
import tvRemoveSignerCode from "#/api/server/mock/rv-tv-saved-signercode-remove.json";
import tvTopups from "#/api/server/mock/rv-tv-topups-transactions.json";
import tvValues from "#/api/server/mock/rv-tv-values.json";

import { Response as MResponse, Server } from "miragejs";
import { ENDPOINTS_ROUTES } from "../endpoints";

export function routes(server: Server, token: string) {
  /**
   *@description BFF Mock routes
   */

  server.get(
    ENDPOINTS_ROUTES.GET_BANNERS(),
    () => new MResponse(200, undefined, bannersMock)
  );

  server.get(
    ENDPOINTS_ROUTES.GET_CATEGORIES(),
    () => new MResponse(200, undefined, categoriesMock)
  );

  server.get(
    ENDPOINTS_ROUTES.GET_PARTNERS(),
    () => new MResponse(200, undefined, categoriesMock)
  );

  server.get(
    ENDPOINTS_ROUTES.GET_BENEFITS(),
    () => new MResponse(200, undefined, benefitsMock)
  );

  server.get(
    ENDPOINTS_ROUTES.GET_PARTNERS_BENEFITS(),
    () => new MResponse(200, undefined, partnerBenefitsMock)
  );

  server.get(
    ENDPOINTS_ROUTES.GET_CATEGORY_PARTNER_ACTIVE(),
    () => new MResponse(200, undefined, categoryPartnerActiveMock)
  );

  server.get(
    ENDPOINTS_ROUTES.GET_LOCATION(),
    () => new MResponse(200, undefined, locationMock)
  );

  server.get(
    ENDPOINTS_ROUTES.GET_PROVIDERS(),
    () => new MResponse(200, undefined, providersMock)
  );

  server.get(
    ENDPOINTS_ROUTES.GET_PORTFOLIO_DETACH(),
    () => new MResponse(200, undefined, portfolioDestaqueAtivo)
  );

  server.get(
    ENDPOINTS_ROUTES.SAVED_CELLPHONES(),
    () => new MResponse(200, undefined, savedCellphoneList)
  );

  server.put(
    ENDPOINTS_ROUTES.SAVED_CELLPHONES(),
    () => new MResponse(200, undefined, savedCellphoneEdit)
  );

  server.delete(
    ENDPOINTS_ROUTES.SAVED_CELLPHONES(),
    () => new MResponse(200, undefined, savedCellphoneRemove)
  );

  server.post(
    ENDPOINTS_ROUTES.POST_CELLPHONES_VALUES(),
    () => new MResponse(200, undefined, portfolioProvidersCellphoneValues)
  );

  server.post(
    ENDPOINTS_ROUTES.CELLPHONE_TOPUPS_TRANSACTIONS(),
    () => new MResponse(200, undefined, cellphoneTransactionResponse)
  );

  server.post(
    ENDPOINTS_ROUTES.TV_TOPUPS_TRANSACTIONS(),
    () => new MResponse(200, undefined, tvTopups)
  );

  server.post(
    ENDPOINTS_ROUTES.PIN_TOPUPS_TRANSACTIONS(),
    () => new MResponse(200, undefined, tvTopups)
  );

  server.delete(
    ENDPOINTS_ROUTES.CELLPHONE_TOPUPS_TRANSACTIONS(),
    () => new MResponse(200, undefined, cellphoneTransactionCancel)
  );

  server.get(
    ENDPOINTS_ROUTES.GET_PIX(),
    () => new MResponse(200, undefined, pix)
  );

  server.get(
    ENDPOINTS_ROUTES.PIX_PAID(),
    () => new MResponse(200, undefined, {})
  );

  server.delete(
    ENDPOINTS_ROUTES.PIX_PAID(),
    () => new MResponse(200, undefined, {})
  );

  server.post(
    ENDPOINTS_ROUTES.POST_PIX(),
    () => new MResponse(200, undefined, pix)
  );

  server.get(
    ENDPOINTS_ROUTES.GET_IMAGE_BY_PROVIDER(),
    () => new MResponse(200, undefined, logoByProvider)
  );

  server.get(
    ENDPOINTS_ROUTES.GET_CUSTOM_IMAGE_BY_PROVIDER(),
    () => new MResponse(200, undefined, logoByProvider)
  );

  server.get(
    ENDPOINTS_ROUTES.TV_SAVED_SIGNERCODE(),
    () => new MResponse(200, undefined, tvListSignerCode)
  );

  server.delete(
    ENDPOINTS_ROUTES.TV_SAVED_SIGNERCODE(),
    () => new MResponse(200, undefined, tvRemoveSignerCode)
  );

  server.put(
    ENDPOINTS_ROUTES.TV_SAVED_SIGNERCODE(),
    () => new MResponse(200, undefined, tvEditSignerCode)
  );

  server.get(
    ENDPOINTS_ROUTES.GET_TV_OFFERS(),
    () => new MResponse(200, undefined, tvOffers)
  );

  server.get(
    ENDPOINTS_ROUTES.GET_TV_OFFER(),
    () => new MResponse(200, undefined, tvOffer)
  );

  server.post(
    ENDPOINTS_ROUTES.GET_TV_VALUES(),
    () => new MResponse(200, undefined, tvValues)
  );

  server.get(
    ENDPOINTS_ROUTES.GET_PIN_ORIENTATION(),
    () => new MResponse(200, undefined, pinOrientation)
  );

  server.get(
    ENDPOINTS_ROUTES.GET_PIN_VALUES(),
    () => new MResponse(200, undefined, pinValues)
  );

  server.get(
    ENDPOINTS_ROUTES.PIN_TOPUPS_TRANSACTIONS(),
    () => new MResponse(200, undefined, pinValue)
  );

  server.get(
    ENDPOINTS_ROUTES.GET_PIN_CART_VALUES(),
    () => new MResponse(200, undefined, pinCartValues)
  );

  server.get(
    ENDPOINTS_ROUTES.USER_EMAIL(),
    () => new MResponse(200, undefined, "john@doe.com")
  );

  server.put(
    ENDPOINTS_ROUTES.USER_EMAIL(),
    () => new MResponse(200, undefined, {})
  );

  server.get(
    ENDPOINTS_ROUTES.GET_RV_CATEGORIES(),
    () => new MResponse(200, undefined, ["Recargas"])
  );

  server.get(
    ENDPOINTS_ROUTES.GET_PRODUCTS(),
    () =>
      new MResponse(200, undefined, [
        {
          titulo: "Recarga de Celular",
          provider: null,
          kind: "cellphone",
          categoria: "Recargas",
          destaque: true,
          ordemDestaque: 0,
          logo: null,
        },
      ])
  );
}
